

import { localSave,lazyLoadingCop} from '@/utils/tools'
import router from '@/router'
import Layout from '@/layout'



export function  addSysRouter(getRouter,lable){
    let routerReal = JSON.parse(JSON.stringify(getRouter))
    checkPermTree(routerReal) //递归将 path 中的 ?label 全部过滤掉
    getNewRouter(routerReal) //过滤菜单数据 从中得到最后的路由
    routerReal = filterAsyncRouter(routerReal) //过滤路由
    routerReal.push({path:'*',component:Layout})
    router.addRoutes(routerReal) //动态添加路由

    //生成菜单
    getRouter = getRouter[0].children[0].children //把路由的前两级过滤掉
    localSave(lable+'_menus',JSON.stringify(getRouter))
    window.SITE_CONFIG['dynamicMenuRoutes']  = getRouter //将路由数据传递给全局变量，做侧边栏菜单渲染工作，菜单渲染
  }

  //递归将 path 中的 ?label 全部过滤掉
export function  checkPermTree(permData){
    let routerArr = []
    permData.forEach(function(p){
      if(p.path){
         routerArr.push(p.path)
        if(p.path.indexOf("?") != -1){
          p.path = p.path.split("?")[0];
          }
       }
      if (p.children && p.children.length > 0) {
         checkPermTree(p.children);
      }
    });
}
// 遍历后台传来的路由字符串，转换为组件对象
export function filterAsyncRouter(asyncRouterMap) {

    const accessedRouters = asyncRouterMap.filter(route => {
      if (route.component) {
        if (route.component === 'Layout') {
          route.component = Layout
        } else {
          try {
            route.component = lazyLoadingCop(route.component) // 导入组件
          } catch (e) {
            console.error(route.component+"-------路径不存在");
            console.error(e);
            return false;
          }
        }
      }else{
        route.component = lazyLoadingCop('sys/base')
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      return true
    })

    return accessedRouters
  }

  // 从菜单中过滤出最终的路由 最多支持到三级
export function  getNewRouter(arr){
    let arrlist=[]
    let arrS=arr;
    arr.filter((el)=>{
      if(el.children!=0){
        el.children.filter((e)=>{
          if(e.children!=0){
            e.children.filter((items)=>{
              if(items.children!=0){
                items.children.filter((item)=>{
                  if(item.children==""||item.children==[]){
                    arrlist.push(item)
                  }
                 if(item.children!=0){
                  item.children.filter((i)=>{
                    arrlist.push(i)
                  })
                 }
                return arrlist
                })

              }
              if(items.children==0){
                arrlist.push(items)
              }

            })
          }
        })
      }

    })
    arrS[0].children[0].children=arrlist
  }
